import { watch } from 'vue'
import { useRoute } from 'vue-router'
import { useThemeManager } from './useThemeManager'
import { useSchoolStore } from '@/store/schoolStore'

export function isDistrictDashboardRoute(route) {
  return route?.name === 'DistrictDashboard'
}

export function useThemeInitializer() {
  const { loadTheme, loadDistrictDashboardTheme, currentTheme, isInitialized } = useThemeManager()
  const schoolStore = useSchoolStore()
  const route = useRoute()

  const syncTheme = async () => {
    try {
      if (isDistrictDashboardRoute(route)) {
        await loadDistrictDashboardTheme()
      } else {
        await loadTheme()
      }
    } catch (error) {
      console.error('Failed to initialize theme:', error)
    }
  }

  watch(
    () => [route.name, schoolStore.currentSchoolId],
    ([name], prev) => {
      const prevName = prev?.[0]
      if (name === 'DistrictDashboard') {
        if (prevName === 'DistrictDashboard') return
        void syncTheme()
        return
      }
      void syncTheme()
    },
    { immediate: true }
  )

  return {
    currentTheme,
    isInitialized
  }
}
